/* ---------------------------------------------------- */
/* Getting cleaned CSS data                             */
/* ---------------------------------------------------- */
window.stlst_legacy.get_clean_css = function( cleanTestRules ) {
	return getGeneratedCSS( cleanTestRules );
}

export default function getGeneratedCSS( cleanTestRules ) {
	let data = getCssByScreensize( 'desktop' );
	// Adding break.
	data = data.replace( /\)\{/g, "){\r" ).replace( /\)\{/g, "){\r" );
	// Clean spaces for nth-child and not.
	const ars = Array(
		"nth-child",
		"not",
		"lang",
		"nth-last-child",
		"nth-last-of-type",
		"nth-of-type"
	);

	for ( let ai = 0; ai < ars.length; ai++ ) {
		// Reg
		let k = new RegExp( ars[ai] + "\\((.*?)\\)\{\r\r", "g" );
		// Replace
		data = data.replace( k, ars[ai] + "\($1\)\{" );
	}

	if ( window.Stylist.iDocJQ.find(".stlst_current_styles").length > 0 ) {
		let mediaArray = [];
		window.Stylist.iDocJQ.find( ".stlst_current_styles" ).each( function() {
			let v = jQuery( this ).attr( "data-size-mode" );

			if ( jQuery.inArray( v, mediaArray ) === -1 && v != 'desktop' ) {
				mediaArray.push( v );
			}
		} )

		jQuery.each( mediaArray, function( i, v ) {

			let q = getCssByScreensize( v )

			// Add extra tab for media query content.
			q = "\t" + q.replace( /\r/g, '\r\t' ).replace( /\t$/g, '' ).replace( /\t$/g, '' );

			if ( v == 'tablet' ) {
				v = '(min-width: 768px) and (max-width: 991px)';
			}

			if ( v == 'mobile' ) {
				v = '(max-width:767px)';
			}

			if ( window.stlst_legacy.isDefined( v ) ){
				data = data + "\r\r@media " + v + "{\r\r" + q + "}";
			}
		} )
	}

	if ( cleanTestRules === true ) {
		data = data.replace( /\r\ta:a !important;/g, "" );
		data = data.replace( /a:a !important;/g, "" );
		data = data.replace( /a:a;/g, "" );
	}

	// Clean first empty lines.
	data = data.replace( /^\r/g, '' ).replace( /^\r/g, '' );
	data = data.replace( /\}\r\r\r\r@media/g, '}\r\r@media' );

	return data;
}

/* ---------------------------------------------------- */
/* Getting CSS styles by screen size                     */
/* ---------------------------------------------------- */
function getCssByScreensize( size ) {

	if ( window.Stylist.iDocJQ.find( ".stlst_current_styles" ).length <= 0 ) {
		return '';
	}

	let totalCreated, classes, selector, data;
	totalCreated = '';

	window.Stylist.iDocJQ.find( ".stlst_current_styles:not(.stlst_step_end)[data-size-mode='" + size + "']" ).each( function() {
		if ( ! jQuery( this ).hasClass( "stlst_step_end" ) ) {
			if ( jQuery( this ).first().html().indexOf( "@media" ) != -1 ) {
				data = jQuery( this ).first().html().split( "{" )[ 1 ] + "{" + jQuery( this ).first().html().split( "{" )[ 2 ].replace( "}}", "}" );
			} else {
				data = jQuery( this ).first().html();
			}

			data = data.replace( /\/\*(.*?)\*\//g, "" );

			selector = data.split( "{" )[ 0 ]
			totalCreated += selector + "{\r"
			classes = jQuery( this ).data( "style" )

			window.Stylist.iDocJQ.find( "style[data-style=" + classes + "][data-size-mode='" + size + "']" ).each( function() {
				let datai;
				if ( jQuery( this ).first().html().indexOf( "@media" ) != -1 ) {
					datai = jQuery( this ).first().html().split( "{" )[ 1 ] + "{" + jQuery( this ).first().html().split( "{" )[ 2 ].replace( "}}", "}" )
				} else {
					datai = jQuery( this ).first().html()
				}

				if ( '' !== datai ) {
					totalCreated += "\t" + datai.split( "{" )[ 1 ].split( "}" )[ 0 ] + ';\r'
					jQuery( this ).addClass( "stlst_step_end" )
				}
			} )
			totalCreated += "}\r\r";
			jQuery( this ).addClass( "stlst_step_end" )
		}
	} )

	window.Stylist.iDocJQ.find( ".stlst_step_end" ).removeClass( "stlst_step_end" )

	return totalCreated;
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-generated-css.js